export const environment = {
    captchaSiteKey: '6LcZJnsqAAAAAC3yr0wOYvSF1bNasO111g_pHj7U',
    apiEndpoint: 'https://faucet-api.statemesh.net',
    // apiEndpoint: 'http://localhost:8081',
};
